var CHONKDEX_SPIN_PREVIEW = Object.freeze({
  turnSource: function (card) {
    return card && typeof card.videoUrl === 'string' && card.videoUrl.trim()
      ? { videoUrl: card.videoUrl.trim(), posterUrl: typeof card.posterUrl === 'string' ? card.posterUrl : '' }
      : null;
  }
});

if (typeof module === 'object' && module.exports) module.exports = CHONKDEX_SPIN_PREVIEW;

(function () {
  if (typeof window === 'undefined') return;
  if (typeof HTMLDialogElement === 'undefined') return;
  document.documentElement.classList.add('product-turn-viewer-ready');

  var svg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 7v5h-5M4 17v-5h5"/><path d="M5.6 9a7 7 0 0 1 11.55-2L20 12M4 12l2.85 5a7 7 0 0 0 11.55-2"/></svg>';
  var dialog = document.createElement('dialog');
  dialog.className = 'dex-spin-dialog';
  dialog.setAttribute('aria-label', '360° render');

  var player = document.createElement('div');
  player.className = 'product-gallery-turn dex-spin-player';
  player.setAttribute('data-product-turn', '');
  player.setAttribute('role', 'group');
  player.setAttribute('aria-label', '360° render. Drag left or right to rotate, or use the left and right arrow keys.');
  player.tabIndex = 0;

  var video = document.createElement('video');
  video.className = 'product-gallery-turn-video dex-spin-video';
  video.muted = true;
  video.playsInline = true;
  video.loop = true;
  video.preload = 'none';
  video.setAttribute('data-turn-video', '');

  var label = document.createElement('span');
  label.className = 'product-gallery-turn-label dex-spin-label';
  label.textContent = '360° render';

  var hint = document.createElement('span');
  hint.className = 'product-gallery-turn-hint dex-spin-hint';
  hint.setAttribute('aria-hidden', 'true');
  hint.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"/><path d="M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"/><path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5"/><path d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1-6 6h-2h.208a6 6 0 0 1-5.012-2.7l-.196-.3c-.312-.479-1.407-2.388-3.286-5.728a1.5 1.5 0 0 1 .536-2.022a1.867 1.867 0 0 1 2.28.28l1.47 1.47"/><path d="M2.541 5.594a13.487 13.487 0 0 1 2.46-1.427"/><path d="M14 3.458c1.32.354 2.558.902 3.685 1.612"/></svg><span>Drag to rotate</span>';

  var close = document.createElement('button');
  close.type = 'button';
  close.className = 'dex-spin-close';
  close.setAttribute('aria-label', 'Close 360° render');
  close.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="m18 6-12 12M6 6l12 12"/></svg>';

  var controls = document.createElement('div');
  controls.className = 'product-gallery-turn-controls dex-spin-controls';
  var play = document.createElement('button');
  play.type = 'button';
  play.className = 'product-gallery-turn-play dex-spin-play';
  play.textContent = 'Play';
  play.setAttribute('aria-label', 'Play 360° turn');
  controls.append(play);

  var error = document.createElement('span');
  error.className = 'dex-spin-error';
  error.setAttribute('role', 'status');
  error.setAttribute('aria-live', 'polite');
  error.hidden = true;

  player.append(video, label, hint, close, controls, error);
  dialog.append(player);
  document.body.append(dialog);

  var activeProductName = 'product';
  var activeTrigger = null;
  var activeProduct = null;
  var rotationTracked = false;
  var pauseRequested = false;
  var playRequested = false;
  function trackPopup(action, inputMethod) {
    if (!activeProduct) return;
    var payload = Object.assign({ action: action }, activeProduct);
    if (inputMethod) payload.input_method = inputMethod;
    window.dispatchEvent(new CustomEvent('ws:track', { detail: { type: 'product_360_popup', payload: payload } }));
  }
  function trackRotation(inputMethod) {
    if (rotationTracked) return;
    rotationTracked = true;
    trackPopup('rotate', inputMethod);
  }
  function setPlayLabel(isPlaying) {
    play.textContent = isPlaying ? 'Pause' : 'Play';
    play.setAttribute('aria-label', (isPlaying ? 'Pause ' : 'Play ') + activeProductName + ' 360° turn');
  }

  function closeViewer() {
    if (dialog.open) trackPopup('close');
    activeProduct = null;
    pauseRequested = false;
    playRequested = false;
    video.pause();
    video.removeAttribute('src');
    while (video.firstChild) video.removeChild(video.firstChild);
    video.load();
    turnPointer = null;
    error.hidden = true;
    error.textContent = '';
    setPlayLabel(false);
    if (dialog.open) dialog.close();
    if (activeTrigger) activeTrigger.focus();
    activeTrigger = null;
  }

  close.addEventListener('click', closeViewer);
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) closeViewer();
  });
  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    closeViewer();
  });
  play.addEventListener('click', function () {
    if (video.paused) {
      playRequested = true;
      video.play().catch(function () {
        playRequested = false;
        error.hidden = false;
        error.textContent = '360° render could not be played.';
      });
    } else { pauseRequested = true; video.pause(); }
  });
  video.addEventListener('play', function () {
    setPlayLabel(true);
    if (playRequested && dialog.open) trackPopup('play');
    playRequested = false;
  });
  video.addEventListener('pause', function () {
    setPlayLabel(false);
    if (pauseRequested && dialog.open) trackPopup('pause');
    pauseRequested = false;
  });
  function showLoadError() {
    if (!dialog.open) return;
    error.hidden = false;
    error.textContent = '360° render could not be loaded.';
    setPlayLabel(false);
  }
  video.addEventListener('error', showLoadError);

  var turnPointer = null;
  player.addEventListener('keydown', function (event) {
    if (event.target !== player || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    if (!Number.isFinite(video.duration) || video.duration <= 0) return;
    event.preventDefault();
    video.pause();
    trackRotation('keyboard');
    var direction = event.key === 'ArrowRight' ? 1 : -1;
    video.currentTime = (video.currentTime + direction / 30 + video.duration) % video.duration;
  });
  player.addEventListener('pointerdown', function (event) {
    if (event.target.closest('button, input') || event.button > 0 || turnPointer) return;
    if (!Number.isFinite(video.duration) || video.duration <= 0) return;
    video.pause();
    turnPointer = { id: event.pointerId, x: event.clientX, time: video.currentTime || 0 };
    player.setPointerCapture(event.pointerId);
  });
  player.addEventListener('pointermove', function (event) {
    if (!turnPointer || event.pointerId !== turnPointer.id || !Number.isFinite(video.duration) || player.clientWidth <= 0) return;
    if (Math.abs(event.clientX - turnPointer.x) >= 6) trackRotation(event.pointerType || 'pointer');
    video.currentTime = ((turnPointer.time - (event.clientX - turnPointer.x) / player.clientWidth * video.duration) % video.duration + video.duration) % video.duration;
  });
  ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (type) {
    player.addEventListener(type, function (event) {
      if (turnPointer && event.pointerId === turnPointer.id) turnPointer = null;
    });
  });

  document.querySelectorAll('.dex-card[data-turn-video]').forEach(function (card) {
    var source = CHONKDEX_SPIN_PREVIEW.turnSource({
      videoUrl: card.dataset.turnVideo,
      posterUrl: card.dataset.turnPoster || ''
    });
    var photo = card.querySelector('.dex-card-photo');
    if (!source || !photo) return;

    var media = document.createElement('div');
    media.className = 'dex-card-media';
    photo.before(media);
    media.append(photo);

    var badge = document.createElement('button');
    badge.type = 'button';
    badge.className = 'dex-spin-badge';
    var productName = card.querySelector('.dex-card-name')?.textContent.trim() || 'product';
    badge.setAttribute('aria-label', 'View ' + productName + ' 360° turn');
    badge.innerHTML = svg;
    badge.append(document.createTextNode('360° render'));
    badge.dataset.turnVideo = source.videoUrl;
    if (source.posterUrl) badge.dataset.turnPoster = source.posterUrl;
    media.append(badge);
  });

  document.addEventListener('click', function (event) {
    var badge = event.target.closest('.product-card-360-badge[data-turn-video], .dex-spin-badge[data-turn-video]');
    if (!badge) return;
    var source = CHONKDEX_SPIN_PREVIEW.turnSource({
      videoUrl: badge.dataset.turnVideo,
      posterUrl: badge.dataset.turnPoster || ''
    });
    if (!source) return;
    event.preventDefault();
    var card = badge.closest('.product-card-alt, .dex-card');
    activeProductName = badge.dataset.productName || card?.querySelector('.dex-card-name')?.textContent.trim() || 'product';
    activeTrigger = badge;
    activeProduct = {
      source: card?.classList.contains('dex-card') ? 'chonkdex' : 'product_card',
      product_id: card?.dataset.productId || null,
      product_handle: card?.dataset.productHandle || null,
      product_title: activeProductName
    };
    rotationTracked = false;
    pauseRequested = false;
    playRequested = false;
    player.setAttribute('aria-label', activeProductName + ' 360° render. Drag left or right to rotate, or use the left and right arrow keys.');
    video.pause();
    video.removeAttribute('src');
    while (video.firstChild) video.removeChild(video.firstChild);
    if (source.posterUrl) video.poster = source.posterUrl;
    else video.removeAttribute('poster');
    var videoSource = document.createElement('source');
    videoSource.src = source.videoUrl;
    videoSource.type = 'video/mp4';
    videoSource.addEventListener('error', showLoadError);
    video.append(videoSource);
    video.preload = 'metadata';
    video.load();
    error.hidden = true;
    error.textContent = '';
    setPlayLabel(false);
    dialog.showModal();
    trackPopup('open');
    close.focus();
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.play().catch(function () { setPlayLabel(false); });
    }
  });
})();
